import { useState } from "react";

const initialState = {
  useSharedLang: () => {
    const [locale, setLocale] = useState("AR");
    const [Lang, setLang] = useState("Arabic");

    const [deliveries, setDeliveries] = useState([
      {
        id: 1,
        name: "عمار الأسعد",
        PayToAdmin: 1000,
        TakeFromAdmin: 2000,
        Counter: 0,
      },
      {
        id: 2,
        name: "ياسر النايف",
        PayToAdmin: 200,
        TakeFromAdmin: 100,
        Counter: 0,
      },
      {
        id: 3,
        name: "أسامة الشعار",
        PayToAdmin: 100,
        TakeFromAdmin: 200,
        Counter: 0,
      },
      {
        id: 4,
        name: "عمر الأبرش",
        PayToAdmin: 200,
        TakeFromAdmin: 100,
        Counter: 0,
      },
    ]);

    var arrayLang = [];
    //   -----------------------<statistics>---------------------------------
    var delegate = [];
    delegate = [
      { orderState: "عمار الأسعد", orderCount: 10 },
      { orderState: "أسامة الشعار", orderCount: 20 },
      { orderState: "ياسر النايف", orderCount: 7 },
      { orderState: "عمار الأسعد", orderCount: 10 },
      { orderState: "عمار الأسعد", orderCount: 10 },
      { orderState: "عمار الأسعد", orderCount: 10 },
    ];

    var landury = [];
    landury = [
      { orderState: "مغسلة الأمين", orderCount: 30 },
      { orderState: "مغسلة التنظيف السعودية", orderCount: 20 },
      { orderState: "مغسلة الأمين فرع 2 ", orderCount: 8 },
      { orderState: "مغسلة الأمين", orderCount: 30 },
      { orderState: "مغسلة الأمين", orderCount: 30 },
      { orderState: "مغسلة الأمين", orderCount: 30 },
    ];

    var moreLanduryUse = [];
    moreLanduryUse = [
      {
        LanName: "مغسلة الأمين",
        rate: 4.5,
        orderCountAccepted: [{ Num: 90, Price: 100 }],
        orderCountComplete: [{ Num: 80, Price: 70 }],
        orderCountDelete: [{ Num: 10, Price: 100 }],
      },
      {
        LanName: "مغسلة الأمين فرع 2",
        rate: 4.2,
        orderCountAccepted: [{ Num: 170, Price: 120, per: 85.4 }],
        orderCountComplete: [{ Num: 140, Price: 50 }],
        orderCountDelete: [{ Num: 30, per: 16.6 }],
      },
      {
        LanName: "مغسلة السعودية",
        rate: 4.5,
        orderCountAccepted: [{ Num: 90, Price: 100 }],
        orderCountComplete: [{ Num: 50, Price: 50 }],
        orderCountDelete: [{ Num: 20 }],
      },
      {
        LanName: "مغسلة السعودية فرع 2",
        rate: 3.7,
        orderCountAccepted: [{ Num: 50, Price: 80 }],
        orderCountComplete: [{ Num: 30, Price: 30 }],
        orderCountDelete: [{ Num: 3 }],
      },
    ];
    const [rateBusi, setRateBusi] = useState({
      followPerYear: [
        {
          year: 2022,
          followPerMonth: [60, 5, 0, 30, 10, 60, 30, 10, 60, 80, 18, 58],
        },
        {
          year: 2021,
          followPerMonth: [10, 5, 80, 30, 10, 30, 30, 9, 10, 60, 8, 18],
        },
      ],
    });

    return {
      locale,
      setLocale,
      deliveries,
      setDeliveries,
      Lang,
      setLang,
      arrayLang,
      delegate,
      landury,
      moreLanduryUse,
      rateBusi,
      setRateBusi,
    };
  },
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE-DATE":
      return {};
    default:
      return state;
  }
};

export default rootReducer;
